import type React from "react";
import { useEffect, useState } from "react";
import { vars } from "../../theme/theme.css";
import { fieldInfoContainerClass } from "./styles.css";

interface FieldMessageProps {
  error?: React.ReactNode;
  info?: React.ReactNode;
  isDisabled?: boolean;
}

function useDelayedUnmount(visible: boolean, delay: number) {
  const [mounted, setMounted] = useState(visible);
  useEffect(() => {
    if (visible) {
      setMounted(true);
      return;
    }
    const t = setTimeout(() => setMounted(false), delay);
    return () => clearTimeout(t);
  }, [visible, delay]);
  return mounted;
}

export function FieldMessage({ error, info, isDisabled }: FieldMessageProps) {
  const content = error ?? info;
  const visible = !!content;
  const mounted = useDelayedUnmount(visible, 200);

  if (!mounted) return null;

  const color = error
    ? vars.colors.red.default
    : isDisabled
      ? vars.colors.neutral.light
      : vars.colors.neutral.dark;

  return (
    <p
      className={fieldInfoContainerClass}
      data-visible={visible ? "true" : "false"}
      style={{ color }}
    >
      {content}
    </p>
  );
}
